import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  Signal,
  Input,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '@auth/services/auth.service';
import { LoadingService } from '@ui/app-layout/loading-service';
import { InputComponent } from '@ui/input/input.component';
import { ModalComponent } from '@ui/modal/modal.component';
import { MODAL_REF, ModalRef, ModalService } from '@ui/modal/modal.service';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs';

@Component({
  selector: 'app-two-factor-modal',
  standalone: true,
  imports: [ModalComponent, InputComponent, ReactiveFormsModule],
  template: `<ui-modal
    [title]="isRequired ? 'Two-factor authenticatie vereist' : 'Two-factor authenticatie'"
    (close)="isRequired ? null : closeModal()"
    (save)="recoveryCodes().length > 0 ? closeModal() : save()"
    [submitText]="recoveryCodes().length > 0 ? 'Sluiten' : 'Verifieer'"
    [hideClose]="isRequired"
    [hideCancel]="isRequired"
  >
    @if(recoveryCodes().length > 0) {
    <p class="mb-4">
      Je hebt 2FA ingeschakeld. Je kunt deze codes gebruiken om in te loggen als
      je je authenticator app niet meer kunt gebruiken.
    </p>

    <div class="grid grid-cols-1 gap-2 mb-4">
      @for (code of recoveryCodes(); track code) {
      <div class="p-2 bg-gray-100 rounded font-mono text-sm">{{ code }}</div>
      }
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center">
      @if(isRequired) {
        <p class="mb-4 text-center">
          Voor extra beveiliging moet je twee-factor-authenticatie instellen voordat je verder kunt gaan.
        </p>
      }
      <p>Scan deze QR code met je authenticator app.</p>
      <img [src]="qrCode()" alt="QR code" />
    </div>
    <ui-input
      type="text"
      placeholder="Code"
      label="Code"
      [formControl]="codeFormControl"
    ></ui-input>
    }
  </ui-modal> `,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoFactorModalComponent {
  authService = inject(AuthService);
  modalService = inject(ModalService);
  loadingService = inject(LoadingService);
  private modalRef = inject(MODAL_REF);
  qrCode = signal('');
  secret = signal('');
  recoveryCodes = signal<string[]>([]);
  codeFormControl = new FormControl('', [Validators.required]);
  token: string | null = null;

  @Input() isRequired = false;

  ngOnInit() {
    this.authService.requestTwoFactor().subscribe((response) => {
      this.token = response.token;
      this.qrCode.set(response.qr_code);
    });
  }

  closeModal() {
    if (this.isRequired && this.recoveryCodes().length > 0) {
      window.location.reload();
      return;
    }
    if (this.modalRef) {
      this.modalService.close(this.modalRef as ModalRef<any>);
    }
  }
  save() {
    this.loadingService.show();
    this.codeFormControl.markAsTouched();
    if (
      this.codeFormControl.valid &&
      this.codeFormControl.value &&
      this.token
    ) {
      this.authService
        .verifyTwoFactor(this.token, this.codeFormControl.value)
        .pipe(
          catchError((error) => {
            console.error(error);
            this.codeFormControl.setErrors({ invalid: true });
            this.loadingService.hide();
            return EMPTY;
          })
        )
        .subscribe((response) => {
          console.log(response);
          this.recoveryCodes.set(response.data.recovery_codes);
          this.loadingService.hide();
        });
    }
  }
}
